import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as xeronote from './types';

const mutations = {
  [xeronote.SET_DEVICE_LIST](state, data) {
    state.deviceList.content = data.content;
    state.deviceList.count = data.count;
  },

  [xeronote.SET_DIV_MONTH](state, data) {
    state.divList.content = data.content;
    state.divList.count = data.count;
  },

  [xeronote.SET_PLANS](state, data) {
    state.plans.content = data.content;
    state.plans.count = data.count;
  },

  [xeronote.SET_TELECOM_LIST](state, data) {
    state.telecomList.content = data.content;
    state.telecomList.count = data.count + 2;
  },

  [xeronote.SET_NICKNAME](state, data) {
    state.nicknameList.content = data.content;
    state.nicknameList.count = data.count;
  },
};

export default mutations;
